import { render, staticRenderFns } from "./Apiaries.vue?vue&type=template&id=ea42b88a&scoped=true&"
import script from "./Apiaries.vue?vue&type=script&lang=js&"
export * from "./Apiaries.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea42b88a",
  null
  
)

export default component.exports